import React, { Component } from "react";
import { Container, Row, Col } from "reactstrap";

import ImgA from "../../assets/images/money.png";
import WaitlistForm from "../../component/WaitlistForm";

class Section extends Component {
  constructor() {
    super();
    const experiments = [
      {
        waitlist_version: 1,
        waitlist_name: "goodwithmoney",
        header: "Tired of your paychecks disappearing too fast?",
        subheader: `Budgeting changed my life—and it can change yours too! My savings went from $0 to over $150k in 2.5 years while earning under $100k and now I’m helping others take control of their finances. Whether you need a weekly or monthly budget plan, I’ll create a personalized strategy that works for YOU. Join my waitlist to get started!`,
        CTA: "I'm ready to start building wealth!",
        img: ImgA,
      },
    ];

    // Check if an experiment is already stored in localStorage
    // const persistedExperiment = localStorage.getItem("selectedExperiment");
    const selectedExperiment = experiments[0];

    // // Save the selected experiment to localStorage if it wasn't already saved
    // if (!persistedExperiment) {
    //   localStorage.setItem(
    //     "selectedExperiment",
    //     JSON.stringify(selectedExperiment)
    //   );
    // }

    this.state = {
      isOpen: false,
      selectedExperiment,
    };

    this.openModal = this.openModal.bind(this);
  }

  openModal() {
    this.setState({ isOpen: true });
  }

  render() {
    const { header, subheader, img } = this.state.selectedExperiment;

    return (
      <React.Fragment>
        <section className="bg-home bg-light" id="home">
          <div className="home-center">
            <div className="home-desc-center">
              <Container>
                <Row className="align-items-center">
                  <Col lg={6}>
                    <div className="home-content">
                      <div className="home-img">
                        <div className="animation-4"></div>
                      </div>
                      <p className="biz-name mt-4 mb-0">GOOD WITH MONEY</p>
                      <h1 className="home-title mt-4">{header}</h1>
                      <p className="text-muted mt-4 f-20">
                        {" "}
                        Last year, I was laid off, and our household income was
                        cut in half overnight. However, my <i>realistic</i>{" "}
                        approach to budgeting allowed us to continue building
                        wealth, increase our credit scores, and pay off over
                        $30,000 in debt. Now, I’m helping others take control of
                        their finances.
                        <br />
                        <br />
                        Whether you need a weekly or monthly budget plan, I’ll
                        create a personalized strategy that works for YOU. The
                        first week is free!
                      </p>
                      <WaitlistForm
                        selectedExperiment={this.state.selectedExperiment}
                      />
                      <p className="text-muted mt-4 f-10 text-center">
                        We'll never share your information with anyone.
                      </p>
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="home-img">
                      <div className="animation-1"></div>
                      <div className="animation-2"></div>
                      <div className="animation-3"></div>
                      <div className="hero">
                        <img
                          src={img}
                          className="img-fluid hero-photo-gmw"
                          alt=""
                        />
                      </div>
                    </div>
                  </Col>
                </Row>
              </Container>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}

export default Section;
